import Logger from "@cappelendamm/logger";
import { BookClubDispatchError, resolveNextRenewAtForBookClub, } from "../utils/resolveNextRenewAt.js";
import { getNextDispatchPrice } from "./getNextDispatchPrice.js";
/**
 * Resolves pricing information for the bokklubb checkout offer message.
 *
 * - No gifts: show firstDispatchPrice as "Første utsendelse koster X".
 * - With gifts: show firstDispatchPrice as "Neste utsendelse etter innmeldingsgave koster X".
 */
export const getBookClubCheckoutDispatchInfo = (subscription) => {
    const hasGifts = subscription.gifts.count > 0;
    try {
        const { selectedDispatch } = resolveNextRenewAtForBookClub(false, subscription.dispatches, { productSku: subscription.sku });
        return {
            hasGifts,
            firstDispatchPrice: getNextDispatchPrice(selectedDispatch, true),
        };
    }
    catch (error) {
        if (!(error instanceof BookClubDispatchError))
            throw error;
        // Price preview must not crash checkout, including signup with gifts.
        // Contract creation still validates and rejects non-gift signup.
        Logger.error(`Cannot resolve book club checkout dispatch for sku: ${subscription.sku}`, error);
        return { hasGifts, firstDispatchPrice: undefined };
    }
};
